import { c as _c } from "react/compiler-runtime";
import { IcoCheckCircle16, IcoSparkles16 } from '@onefootprint/icons';
type WalkthroughEventProps = {
  event: 'started' | 'continued' | 'ended' | 'finished';
  title: string;
};
const WalkthroughEvent = t0 => {
  const $ = _c(15);
  const {
    event,
    title
  } = t0;
  let t1;
  if ($[0] !== event) {
    t1 = (event === "started" || event === "continued") && <IcoSparkles16 />;
    $[0] = event;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== event) {
    t2 = (event === "ended" || event === "finished") && <IcoCheckCircle16 color="success" />;
    $[2] = event;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <span className="mt-px shrink-0 text-accent" aria-hidden={true}>{t1}{t2}</span>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== title) {
    t4 = <span className="font-medium text-primary">{title}</span>;
    $[7] = title;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== event || $[10] !== t4) {
    t5 = <span>You {event} the walkthrough {t4}</span>;
    $[9] = event;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <div className="flex items-start justify-center gap-2 py-1 text-body-3 text-tertiary">{t3}{t5}</div>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default WalkthroughEvent;